"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PasswordHelperCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("./styles/color"));
var _Icon = _interopRequireDefault(require("./Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
/* eslint-disable react-native/no-raw-text */
var ParentContainer = _styledComponents["default"].div.withConfig({
  displayName: "ParentContainer",
  componentId: "sc-q6fxq8-0"
})(["grid-area:card;background-color:", ";border:2px solid ", ";width:auto;height:auto;display:grid;padding:10px 0 40px 0;grid-template-areas:\"group closeIcon\";"], _color["default"].white, _color["default"].warning);
ParentContainer.displayName = 'ParentContainer';
var GroupContainer = _styledComponents["default"].div.withConfig({
  displayName: "GroupContainer",
  componentId: "sc-q6fxq8-1"
})(["background-color:", ";display:grid;grid-template-rows:repeat(3,1fr);grid-area:group;padding-top:20px;"], _color["default"].white);
GroupContainer.displayName = 'GroupContainer';
var RowContainer = _styledComponents["default"].div.withConfig({
  displayName: "RowContainer",
  componentId: "sc-q6fxq8-2"
})(["background-color:", ";font-family:Raleway,serif;font-weight:500;font-size:16px;color:", ";letter-spacing:0;text-align:left;margin:20px 20px 0 20px;"], _color["default"].white, _color["default"].lightTextDefault);
RowContainer.displayName = 'RowContainer';
var ChildContainer = _styledComponents["default"].div.withConfig({
  displayName: "ChildContainer",
  componentId: "sc-q6fxq8-3"
})(["background-color:", ";border:1px solid ", ";border-radius:5px;width:auto;height:36px;margin-top:10px;"], _color["default"].white, _color["default"].warning);
ChildContainer.displayName = 'ChildContainer';
var ChildTextContainer = _styledComponents["default"].div.withConfig({
  displayName: "ChildTextContainer",
  componentId: "sc-q6fxq8-4"
})(["background-color:", ";color:", ";font-family:Raleway,serif;font-size:14px;font-weight:400;line-height:17px;width:auto;text-align:left;margin-top:10px;margin-left:10px;"], _color["default"].white, _color["default"].white);
ChildTextContainer.displayName = 'ChildTextContainer';
var CloseContainer = _styledComponents["default"].div.withConfig({
  displayName: "CloseContainer",
  componentId: "sc-q6fxq8-5"
})(["background-color:", ";grid-area:closeIcon;text-align:right;padding-right:15px;height:24px;svg{width:24px;height:24px;}"], _color["default"].white);
CloseContainer.displayName = 'CloseContainer';
var PasswordHelperCard = function PasswordHelperCard(props) {
  return /*#__PURE__*/_react["default"].createElement(ParentContainer, null, /*#__PURE__*/_react["default"].createElement(CloseContainer, {
    "data-cy": "passwordHelperCard",
    onClick: props.onClose
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    iconName: "x",
    size: "2x",
    color: _color["default"].darkPrimary
  })), /*#__PURE__*/_react["default"].createElement(GroupContainer, null, /*#__PURE__*/_react["default"].createElement(RowContainer, null, props.messages.specialCharacter, /*#__PURE__*/_react["default"].createElement(ChildContainer, null, /*#__PURE__*/_react["default"].createElement(ChildTextContainer, null, "# ? ! @ $ % ^ & * -"))), /*#__PURE__*/_react["default"].createElement(RowContainer, null, props.messages.numberCharacter, /*#__PURE__*/_react["default"].createElement(ChildContainer, null, /*#__PURE__*/_react["default"].createElement(ChildTextContainer, null, "0 1 2 3 4 5 6 7 8 9"))), /*#__PURE__*/_react["default"].createElement(RowContainer, null, props.messages.alphaCharacter, /*#__PURE__*/_react["default"].createElement(ChildContainer, null, /*#__PURE__*/_react["default"].createElement(ChildTextContainer, null, "Aa-Zz")))));
};
exports.PasswordHelperCard = PasswordHelperCard;
var _default = PasswordHelperCard;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(ParentContainer, "ParentContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/PasswordHelperCard.js");
  reactHotLoader.register(GroupContainer, "GroupContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/PasswordHelperCard.js");
  reactHotLoader.register(RowContainer, "RowContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/PasswordHelperCard.js");
  reactHotLoader.register(ChildContainer, "ChildContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/PasswordHelperCard.js");
  reactHotLoader.register(ChildTextContainer, "ChildTextContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/PasswordHelperCard.js");
  reactHotLoader.register(CloseContainer, "CloseContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/PasswordHelperCard.js");
  reactHotLoader.register(PasswordHelperCard, "PasswordHelperCard", "/Users/crs/WebstormProjects/michelangelo/src/Components/PasswordHelperCard.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/PasswordHelperCard.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();